/*
 * Нативний предиктивний пошук artistpush (адаптація фрейму Promosound, 09.2026).
 * - Локальний індекс з /products.json (одне завантаження, ≤250 товарів):
 *   бачить ВСІ активні товари, включно з прихованими від Google (seo.hidden) —
 *   саме тому Spotify/SoundCloud знаходяться, хоча Boost/нативний suggest їх не бачить.
 * - Індексуємо title + handle + product_type + tags: Spotify-товари не містять
 *   слова "spotify" у назвах, але містять у тегах.
 * - TYPO-словник + fuzzy по скелету слова (spt→spotify), AND-матч токенів.
 * - Стара сторінка /search прихованих товарів не бачить, тому ми туди НЕ
 *   ведемо: Enter і «Show all» — або колекція платформи, або перший результат.
 * Vanilla, без залежностей. Аналітика: dataLayer + Clarity через psTrack.
 */
(function () {
  'use strict';

  /* ── аналітика: черга + idle, GA4 (dataLayer) + Clarity ── */
  var _q = [], _sch = false;
  function _flush() {
    _sch = false;
    var batch = _q.splice(0);
    batch.forEach(function (ev) {
      try {
        window.dataLayer = window.dataLayer || [];
        var payload = { event: ev.name };
        if (ev.params) for (var k in ev.params) payload[k] = ev.params[k];
        window.dataLayer.push(payload);
      } catch (e) {}
      try {
        if (window.clarity) {
          window.clarity('event', ev.name);
          if (ev.tags) Object.keys(ev.tags).forEach(function (k) { window.clarity('set', k, String(ev.tags[k])); });
        }
      } catch (e) {}
    });
  }
  function _schedule() {
    if (_sch) return; _sch = true;
    if (window.requestIdleCallback) requestIdleCallback(_flush, { timeout: 2000 }); else setTimeout(_flush, 0);
  }
  function psTrack(name, params, tags) { _q.push({ name: name, params: params, tags: tags }); _schedule(); }
  window.addEventListener('pagehide', _flush);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') _flush(); });

  /* ── конфіг ── */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN = 1, DEBOUNCE = 120, LIMIT = 8;

  var input, box, timer, clearBtn, lastQuery = '';
  var trackTimer, lastTracked = ''; // GA4: лише усталений запит, а не кожна літера
  var IS_DE = false, BS_URL = '/collections/best-sellers';

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* ── локальний індекс каталогу ── */
  var INDEX = null, indexLoading = false;

  // Кеш індексу в sessionStorage на 30 хв (як каталог у кошику): другий і
  // наступні пошуки не чекають products.json (600 KB) і не перемальовують
  // список після довантаження — саме та перемальовка губила тап на мобайлі.
  var IDX_KEY = 'ap_search_index_v1:' + ROOT, IDX_TTL = 30 * 60 * 1000;
  function readIdxCache() {
    try {
      var raw = sessionStorage.getItem(IDX_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || !o.i || !o.i.length || (Date.now() - o.t) > IDX_TTL) return null;
      return o.i;
    } catch (e) { return null; }
  }
  function writeIdxCache(i) {
    try { sessionStorage.setItem(IDX_KEY, JSON.stringify({ t: Date.now(), i: i })); } catch (e) {}
  }

  function loadIndex() {
    if (INDEX || indexLoading) return;
    var cached = readIdxCache();
    if (cached) { INDEX = cached; return; }
    indexLoading = true;
    fetch(ROOT + 'products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        INDEX = (d.products || []).map(function (p) {
          var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); });
          var mn = prices.length ? Math.min.apply(null, prices) : null;
          var mx = prices.length ? Math.max.apply(null, prices) : null;
          var img = (p.images && p.images[0] && p.images[0].src) || null;
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
          var hay = p.title + ' ' + p.handle.replace(/-/g, ' ') + ' ' +
            (p.product_type || '') + ' ' + ((p.tags || []).join(' '));
          return {
            t: p.title,
            words: hay.toLowerCase().split(/[^a-z0-9]+/),
            u: ROOT + 'products/' + p.handle,
            img: img,
            pm: mn, varies: mn !== null && mn !== mx
          };
        });
        writeIdxCache(INDEX);
        // Поки індекс вантажився, могли показатись результати нативного
        // suggest — а він прихованих товарів не бачить. Переобчислюємо
        // поточний запит, щоб людина не лишилась із неповним списком
        // (paint() сам не перемалює список, поки на ньому тримають палець).
        var modal = document.getElementById('search-modal');
        if (lastQuery && lastQuery.length >= MIN && modal && modal.classList.contains('active')) {
          run(lastQuery);
        }
      })
      .catch(function () { indexLoading = false; });
  }

  function scoreProduct(pr, tokens) {
    var total = 0;
    for (var i = 0; i < tokens.length; i++) {
      var tk = tokens[i], best = 0;
      for (var w = 0; w < pr.words.length; w++) {
        var word = pr.words[w];
        if (!word) continue;
        if (word === tk) { best = Math.max(best, 5); }
        else if (word.indexOf(tk) === 0) { best = Math.max(best, 4); }
        else if (word.replace(/[aeiou]/g, '').indexOf(tk) === 0 && tk.length >= 2) { best = Math.max(best, 2); }
        else if (word.indexOf(tk) > 0) { best = Math.max(best, 1); }
      }
      if (!best) return 0; // всі токени мають матчитись (AND)
      total += best;
    }
    return total;
  }

  // Службові слова не несуть сенсу для AND-матчингу («comments for youtube» падало на «for»).
  var STOP = ['for','your','you','the','a','an','of','on','to','in','my','and','buy','get','with','us'];
  function localSearch(nq) {
    var all = nq.split(/[^a-z0-9]+/).filter(Boolean);
    var tokens = all.filter(function (t) { return STOP.indexOf(t) === -1; });
    if (!tokens.length) tokens = all; // запит лише зі стоп-слів — шукаємо як є
    if (!tokens.length) return [];
    var out = [];
    for (var i = 0; i < INDEX.length; i++) {
      var sc = scoreProduct(INDEX[i], tokens);
      if (sc > 0) out.push([sc, INDEX[i]]);
    }
    out.sort(function (a, b) { return b[0] - a[0] || a[1].t.length - b[1].t.length; });
    return out.slice(0, LIMIT).map(function (x) { return x[1]; });
  }

  /* ── типо-словник і fuzzy платформ ── */
  var TYPO = {
    'yotube': 'youtube', 'youtub': 'youtube', 'utube': 'youtube', 'you tube': 'youtube', 'yt': 'youtube',
    'spotifi': 'spotify', 'spotefy': 'spotify', 'sportify': 'spotify', 'spotfy': 'spotify', 'spoti': 'spotify', 'spotifu': 'spotify', 'sprotfy': 'spotify',
    'tiktoc': 'tiktok', 'tik tok': 'tiktok', 'tick tock': 'tiktok',
    'instagramm': 'instagram', 'insta': 'instagram', 'ig': 'instagram', 'isngagfam': 'instagram', 'isngag': 'instagram', 'isngagf': 'instagram',
    'blogd': 'blog', 'blogs': 'blog',
    'facebok': 'facebook', 'fb': 'facebook',
    'beatpot': 'beatport', 'beat port': 'beatport',
    'sound cloud': 'soundcloud', 'scloud': 'soundcloud', 'sondcloud': 'soundcloud', 'soundclod': 'soundcloud',
    'subs': 'subscribers', 'subscibers': 'subscribers',
    'folowers': 'followers', 'followrs': 'followers',
    'streams': 'plays',
    'listeners': 'monthly listeners',
    'hörer': 'monthly listeners', 'horer': 'monthly listeners',
    'abonnenten': 'subscribers', 'aufrufe': 'views'
  };

  var PLATFORMS = ['spotify', 'youtube', 'tiktok', 'instagram', 'facebook', 'soundcloud',
    'beatport', 'mixcloud', 'deezer', 'tidal', 'twitch', 'threads', 'bandcamp', 'audiomack',
    'traxsource', 'itunes', 'apple', 'discord', 'boomplay', 'billboard', 'radio', 'twitter'];

  function fuzzyPlatform(tok) {
    if (tok.length < 3) return null;
    for (var i = 0; i < PLATFORMS.length; i++) {
      var pl = PLATFORMS[i];
      var skel = pl.replace(/[aeiou]/g, '');
      if (pl.indexOf(tok) === 0 || skel.indexOf(tok) === 0) return pl;
    }
    return null;
  }

  function normalizeQuery(q) {
    var n = ' ' + q.toLowerCase().trim() + ' ';
    for (var k in TYPO) {
      if (n.indexOf(' ' + k + ' ') !== -1) n = n.split(' ' + k + ' ').join(' ' + TYPO[k] + ' ');
    }
    n = n.trim().split(/\s+/).map(function (t) {
      if (PLATFORMS.indexOf(t) !== -1) return t;
      return fuzzyPlatform(t) || t;
    }).join(' ');
    return n;
  }

  /* ── рендер рядків ── */
  function money(v) { return '$' + (v % 1 ? v.toFixed(2) : v); }

  function rowLocal(pr) {
    var pv = pr.pm != null ? ((pr.varies ? '<span class="psq-row__from">From</span> ' : '') + money(pr.pm)) : '';
    var price = pv ? '<span class="psq-row__price">' + pv + '</span>' : '';
    var ico = pr.img
      ? '<span class="psq-row__ico" style="background-image:url(' + pr.img + ')"></span>'
      : '<span class="psq-row__ico"></span>';
    return '<a class="psq-row" href="' + pr.u + '">' + ico +
      '<span class="psq-row__title">' + esc(pr.t) + '</span>' + price +
      '<svg class="psq-row__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
  }

  function rowNative(p) {
    var pv = '';
    if (p.price != null) {
      var varies = (p.price_min != null && p.price_max != null && p.price_min !== p.price_max);
      pv = (varies ? '<span class="psq-row__from">From</span> ' : '') + '$' + esc(String(p.price));
    }
    var price = pv ? '<span class="psq-row__price">' + pv + '</span>' : '';
    var ico = p.image
      ? '<span class="psq-row__ico" style="background-image:url(' + p.image + ')"></span>'
      : '<span class="psq-row__ico"></span>';
    return '<a class="psq-row" href="' + p.url + '">' + ico +
      '<span class="psq-row__title">' + esc(p.title) + '</span>' + price +
      '<svg class="psq-row__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
  }

  /* ── Popular-чипи: перехід на колекції (усі перевірені на 200, EN і DE).
     Spotify/SoundCloud — робочі колекції (стандартні хендли закриті/301). ── */
  var POPULAR = [
    ['TikTok', 'collections/tik-tok-promotion'],
    ['YouTube', 'collections/youtube-promotion'],
    ['Instagram', 'collections/instagram-promotion'],
    ['Spotify', 'collections/music-growth-for-artists'],
    ['SoundCloud', 'collections/promo-services-for-soundcloud-users'],
    ['Beatport', 'collections/beatport-promotion']
  ];

  /* Enter і «Show all» ведуть на КОЛЕКЦІЮ платформи, а не на /search:
     нативна search-сторінка hidden-товарів не показує, колекція — показує. */
  var SPECIAL = {
    'spotify': 'collections/music-growth-for-artists',
    'soundcloud': 'collections/promo-services-for-soundcloud-users',
    'tiktok': 'collections/tik-tok-promotion',
    'youtube': 'collections/youtube-promotion',
    'instagram': 'collections/instagram-promotion',
    'beatport': 'collections/beatport-promotion'
  };
  function specialTarget(nq) {
    var toks = nq.split(/[^a-z0-9]+/);
    for (var i = 0; i < toks.length; i++) {
      if (SPECIAL[toks[i]]) return ROOT + SPECIAL[toks[i]];
    }
    return null;
  }

  function chipsHtml(msg) {
    var html = '<div class="psq-empty"><p class="psq-empty__msg">' + msg + '</p><div class="psq-chips">';
    POPULAR.forEach(function (p) {
      html += '<a class="psq-chip" href="' + ROOT + p[1] + '">' + p[0] + '</a>';
    });
    return html + '</div></div>';
  }

  function noMatch() {
    return chipsHtml(IS_DE ? 'Nichts gefunden. Beliebte Plattformen:' : 'No matches. Explore popular platforms:');
  }

  function getRecent() {
    try { return JSON.parse(localStorage.getItem('psq_recent') || '[]'); } catch (e) { return []; }
  }
  function saveRecent(q) {
    if (!q || q.length < MIN) return;
    try {
      var r = getRecent().filter(function (x) { return x !== q; });
      r.unshift(q);
      localStorage.setItem('psq_recent', JSON.stringify(r.slice(0, 3)));
    } catch (e) {}
  }

  function renderEmpty() {
    var html = '';
    var recent = getRecent();
    if (recent.length) {
      html += '<div class="psq-group__label">' + (IS_DE ? 'Zuletzt gesucht' : 'Recent') + '</div><div class="psq-chips psq-chips--recent">';
      recent.forEach(function (r) {
        html += '<button type="button" class="psq-chip psq-chip--recent psq-chip--q" data-q="' + esc(r) + '">' + esc(r) + '</button>';
      });
      html += '</div>';
    }
    html += chipsHtml(IS_DE ? 'Beliebte Suchen:' : 'Popular searches:');
    html += '<div class="psq-actions">' +
      '<a class="psq-chip psq-chip--bsone" href="' + BS_URL + '">' + (IS_DE ? 'Bestseller' : 'Best Sellers') + '</a>' +
      '</div>';
    paint(html);
  }

  // Кнопка внизу списку веде на колекцію платформи. Для запитів без колекції
  // її не показуємо взагалі — стара сторінка /search прихованих товарів
  // не бачить, тож вести туди немає сенсу.
  function footer(q) {
    var href = specialTarget(normalizeQuery(q));
    if (!href) return '';
    return '<a class="psq-all" href="' + href + '">' +
      (IS_DE ? 'Alle Ergebnisse anzeigen' : 'Show all results') + ' &rarr;</a>';
  }

  function run(q) {
    var nq = normalizeQuery(q);

    if (INDEX) {
      var hits = localSearch(nq);
      if (!hits.length) {
        paint(noMatch());
        psTrack('search_no_results', { q: q }, { search_term: q });
        return;
      }
      var parts = hits.map(rowLocal);
      parts.push(footer(q));
      paint(parts.join(''));
      return;
    }

    // Фолбек, поки індекс вантажиться: нативний suggest (hidden-товари тут не з'являться)
    fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(nq) +
        '&resources[type]=product&resources[limit]=' + LIMIT +
        '&resources[options][prefix]=last&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d.resources && d.resources.results && d.resources.results.products) || []; })
      .catch(function () { return []; })
      .then(function (products) {
        if (q !== lastQuery) return; // застарілий запит
        if (INDEX) return; // індекс уже встиг завантажитись і перемалював список
        if (!products.length) {
          // Нативний suggest не бачить прихованих товарів — «нема результатів» звітує лише повний індекс.
          paint(noMatch());
          return;
        }
        var parts = products.map(rowNative);
        parts.push(footer(q));
        paint(parts.join(''));
      });
  }

  function syncClear() { if (clearBtn) clearBtn.hidden = !input.value.length; }

  /* ── малювання списку без «вбивання» тапа ──
     Мобільний баг: список перемальовувався (innerHTML) у момент, коли палець
     уже лежав на рядку → вузол, по якому тапнули, зникав і click губився.
     Тому: 1) поки pointer притиснутий до списку — не перемальовуємо, лише
     запам'ятовуємо; малюємо через ~350 мс після відпускання (після click);
     2) однаковий HTML не перемальовуємо взагалі. */
  var pressing = false, pendingHtml = null, lastHtml = '', pressWatch = null;
  function paint(html) {
    if (pressing) { pendingHtml = html; return; }
    if (html !== lastHtml) { box.innerHTML = html; lastHtml = html; }
    box.hidden = false;
  }
  function pressStart() {
    pressing = true;
    clearTimeout(pressWatch);
    pressWatch = setTimeout(pressEnd, 1500); // страховка: якщо pointerup загубився (курсор пішов за вікно)
  }
  function pressEnd() {
    clearTimeout(pressWatch);
    if (!pressing) return;
    pressing = false;
    if (pendingHtml === null) return;
    setTimeout(function () {
      if (pressing || pendingHtml === null) return;
      var h = pendingHtml; pendingHtml = null; paint(h);
    }, 350);
  }

  function onInput() {
    var q = input.value.trim();
    lastQuery = q;
    clearTimeout(timer);
    syncClear();
    if (q.length < MIN) { renderEmpty(); return; }
    timer = setTimeout(function () { run(q); }, DEBOUNCE);
    clearTimeout(trackTimer);
    if (q.length >= 3) {
      trackTimer = setTimeout(function () {
        if (q === lastQuery && q !== lastTracked) { lastTracked = q; psTrack('search_query', { search_term: q }); }
      }, 900);
    }
  }

  function highlight(dir) {
    var rows = Array.prototype.slice.call(box.querySelectorAll('.psq-row, .psq-all'));
    if (!rows.length) return;
    var cur = box.querySelector('.is-hl');
    var i = cur ? rows.indexOf(cur) + dir : (dir > 0 ? 0 : rows.length - 1);
    if (cur) cur.classList.remove('is-hl');
    if (i >= 0 && i < rows.length) {
      rows[i].classList.add('is-hl');
      rows[i].scrollIntoView({ block: 'nearest' });
    }
  }

  /* ── модал ── */
  function openModal(src) {
    var modal = document.getElementById('search-modal');
    if (!modal) return;
    loadIndex();
    modal.classList.add('active');
    setTimeout(function () {
      input.focus();
      syncClear();
      var q = input.value.trim();
      if (q.length < MIN) { renderEmpty(); } else { lastQuery = q; run(q); }
    }, 50);
    psTrack('search_open', { src: src || 'icon' });
  }
  function closeModal() {
    var modal = document.getElementById('search-modal');
    modal && modal.classList.remove('active');
  }

  function init() {
    input = document.getElementById('Search');
    box = document.getElementById('psq-results');
    clearBtn = document.getElementById('psq-clear');
    if (!input || !box) return;
    IS_DE = box.getAttribute('data-de') === '1';
    BS_URL = box.getAttribute('data-bs-url') || BS_URL;

    // Віджет рендериться всередині секції хедера, а та має position:fixed +
    // z-index:999 і створює ВЛАСНИЙ ШАР: усе, що на сторінці вище 999
    // (промо-смуга eSputnik, банер cookie), накривало наше поле на мобільному.
    // Виносимо оверлей прямо в <body> — тоді z-index працює як задумано.
    var modalRoot = document.getElementById('search-modal');
    if (modalRoot && modalRoot.parentNode !== document.body) {
      document.body.appendChild(modalRoot);
    }

    syncClear();

    input.addEventListener('input', onInput);
    input.addEventListener('focus', loadIndex);

    // Усі вбудовані точки входу пошуку теми. Їхні поля лежать у формах
    // action="/search", а лупа — submit-кнопка: без перехоплення клік
    // відправляє форму і браузер іде на стару сторінку /search?q=.
    // Тому слухаємо у ФАЗІ ЗАХОПЛЕННЯ і глушимо і click, і submit.
    var ENTRY = '.search-scroll, .header__search, .header__search-mob, .search-mob-container, .overlay-menu .search-container, .search-icon-mob, .search-icon';

    function fromTheme(el) {
      if (!el || !el.closest) return false;
      if (el.closest('#search-modal')) return false; // наш власний віджет — не чіпаємо
      return !!el.closest(ENTRY);
    }

    document.addEventListener('click', function (e) {
      if (!fromTheme(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      var closeBtn = document.getElementById('closeButton');
      closeBtn && closeBtn.click();
      // перенести вже набране (якщо людина щось встигла ввести у поле теми)
      var f = e.target.closest('form');
      var themeInput = f && f.querySelector('input[name="q"]');
      if (themeInput && themeInput.value.trim()) input.value = themeInput.value.trim();
      openModal('header');
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.closest('#search-modal')) return; // наш submit працює як був
      var q = form.querySelector('input[name="q"]');
      if (!q) return;
      var act = (form.getAttribute('action') || '');
      if (act.indexOf('/search') === -1) return;
      e.preventDefault();
      e.stopPropagation();
      if (q.value.trim()) input.value = q.value.trim();
      openModal('header-submit');
    }, true);

    // Тап по полю (без кліку по кнопці) теж відкриває наш оверлей
    document.addEventListener('pointerdown', function (e) {
      if (!fromTheme(e.target)) return;
      e.preventDefault();
      loadIndex(); // prefetch: індекс встигає прийти, поки відкривається оверлей
    }, true);

    // палець/курсор на списку підказок → paint() відкладає перемальовку
    box.addEventListener('pointerdown', pressStart);
    box.addEventListener('touchstart', pressStart, { passive: true });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (ev) {
      document.addEventListener(ev, pressEnd, true);
    });
    window.addEventListener('blur', pressEnd);

    clearBtn && clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      syncClear();
      renderEmpty();
    });

    var closeBtn = document.getElementById('close-modal');
    closeBtn && closeBtn.addEventListener('click', closeModal);
    var backBtn = document.getElementById('psq-back'); /* mobile: стрілка «назад» зліва в полі */
    backBtn && backBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    var modal = document.getElementById('search-modal');
    modal && modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    // Enter: 1) колекція платформи, якщо запит про платформу; 2) інакше —
    // перший знайдений товар; 3) якщо нічого не знайшли — лишаємось у пошуку
    // (на стару сторінку /search не кидаємо: вона hidden-товарів не бачить).
    var form = input.closest('form');
    form && form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) return;
      saveRecent(q);
      var sp = specialTarget(normalizeQuery(q));
      if (sp) { window.location.href = sp; return; }
      var first = box.querySelector('.psq-row');
      if (first) { window.location.href = first.getAttribute('href'); }
    });

    // кліки всередині підказок
    box.addEventListener('click', function (e) {
      var qc = e.target.closest('.psq-chip--q');
      if (qc) {
        input.value = qc.getAttribute('data-q') || '';
        input.focus();
        onInput();
        return;
      }
      var a = e.target.closest('.psq-row, .psq-all, .psq-chip:not(.psq-chip--q)');
      if (a) {
        a.classList.add('is-loading');
        saveRecent(input.value.trim());
        psTrack('search_suggest_click', { href: a.getAttribute('href'), search_term: input.value.trim() }, { search_term: input.value.trim() });
      }
    });

    // клавіатура: ↑↓ по рядках, Enter по підсвіченому
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(-1); }
      else if (e.key === 'Enter') {
        var hl = box.querySelector('.is-hl');
        if (hl) { e.preventDefault(); saveRecent(input.value.trim()); window.location.href = hl.getAttribute('href'); }
      }
    });
  }

  // bfcache-повернення: прибрати залишкові лоадери
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('#psq-results .is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
